// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__5l9yC","additionalInfo":"AgreementModal_additionalInfo__PsMnB"};